export default function getDataOrAriaProps(props) {
    return Object.keys(props).reduce((prev, key) => {
        if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'data_' || key === 'role') &&
            key.substr(0, 7) !== 'data-__') {
            prev[key] = props[key];
        }
        return prev;
    }, {});
}
